import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { useContext, useState } from "react";
import { Box, Flex } from "theme-ui";
import { DropDownContext, Label2 } from "../../index";
export const FilterDropDown = ({ label, initShow = false, cardStyle = {}, children }) => {
    const context = useContext(DropDownContext);
    const [localState, setShow] = useState((context && context.current === label) || initShow || false);
    const toggle = () => {
        if (context) {
            context.toggle(label);
            setShow(!show);
        }
        else {
            setShow(!show);
        }
    };
    const show = (context && context.current === label) || (!context && localState);
    return (_jsxs(Flex, { sx: {
            backgroundColor: show ? "blue.1" : "blue.2",
            margin: "0 1px 0 1px"
        }, children: [_jsxs(Flex, { sx: {
                    color: "white.0",
                    flexGrow: 1,
                    px: 24,
                    height: 64,
                    alignItems: "center",
                    cursor: "pointer"
                }, onClick: toggle, onKeyPress: event => {
                    if (event.key === "Enter")
                        toggle();
                }, role: "button", tabIndex: 0, "aria-expanded": show, children: [_jsx(Label2, { sx: { marginRight: 8 }, children: label }), _jsx(Flex, { sx: {
                            mt: 2,
                            flex: 1,
                            alignItems: "center",
                            justifyContent: "center"
                        }, children: show ? (_jsx("svg", { width: "8", height: "6", viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M0 5.66662L4 2.04197L8 5.66663V3.95795L4 0.333292L0 3.95795V5.66662Z", fill: "currentColor" }) })) : (_jsx("svg", { width: "8", height: "6", viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M8 0.333314L4 3.95797L0 0.333313L0 2.04199L4 5.66665L8 2.04199V0.333314Z", fill: "currentColor" }) })) })] }), show && (_jsx(Box, { sx: Object.assign({ position: "absolute" }, cardStyle), children: children }))] }));
};
//# sourceMappingURL=FilterDropDown.js.map